import React from 'react';
import { useNavigate } from 'react-router-dom';
import RoutesName from '../../../RoutesName';
import { useTranslate } from '../../../components/TranslationText';
import moment from 'moment';

export default function DecisionCard({ decision }) {
    const { translate } = useTranslate();
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate(`${RoutesName.DISCIPLINARY_DECISIONS}/${decision.id}`);
    };

    return (
        <div 
            className="bg-white border-15 mb-4 border-0 d-flex flex-column" 
            style={{ cursor: 'pointer', transition: 'transform 0.2s', overflow: 'hidden' }}
            onClick={handleCardClick}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
            <div className="bg-light d-flex justify-content-between align-items-center px-4 py-3" style={{ borderBottom: '1px solid #eee' }}>
                <div className="d-flex align-items-center gap-3">
                    <span className="badge bg-secondary text-dark bg-opacity-10 rounded-1 px-3 py-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
                        <i className="fa-solid fa-building-columns me-2 text-danger"></i>
                        {decision.source}
                    </span>
                    <span className="text-muted" style={{ fontSize: '12px', fontWeight: '500' }}>
                        <i className="fa-regular fa-calendar me-2 text-danger"></i>
                        {moment(decision.decisionDate).format('DD MMM YYYY')}
                    </span>
                </div>
                <span 
                    className="badge bg-danger text-white rounded-1 px-3 py-1"
                    style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                >
                    {decision.reason}
                </span>
            </div>
            <div className="px-4 pt-4 pb-3">
                <div className="row">
                    <div className="col-md-5 mb-3 mb-md-0 border-end pe-4">
                        <div className="text-muted mb-1" style={{ fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase', fontWeight: 'bold' }}>
                            {decision.horse ? translate('web.horse', 'HORSE') : translate('web.handler', 'HANDLER')}
                        </div>
                        <h4 className="fw-bold mb-2 text-dark" style={{ fontSize: '1.2rem' }}>
                            {decision.horse ? decision.horse.name : decision.handler?.name}
                        </h4>
                        {decision.horse && (
                            <p className="text-muted mb-0" style={{ fontSize: '12px', fontWeight: '500' }}>
                                {decision.horse.color} • DOB: {moment(decision.horse.dob).format('DD MMM YYYY')} • Reg No: {decision.horse.regNo} • Studbook: {decision.horse.studbook}
                            </p>
                        )}
                    </div>

                    <div className="col-md-4 mb-3 mb-md-0 border-end px-4">
                        <div className="text-muted mb-1" style={{ fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase', fontWeight: 'bold' }}>
                            {translate('web.show', 'SHOW')}
                        </div>
                        <div className="d-flex align-items-start">
                            <i className="fa-solid fa-trophy text-danger mt-1 me-2" style={{ fontSize: '14px' }}></i>
                            <div>
                                <p className="mb-1 fw-bold text-dark" style={{ fontSize: '14px' }}>
                                    {decision.show?.name}
                                </p>
                                <p className="text-muted mb-0" style={{ fontSize: '12px', fontWeight: '500' }}>
                                    {decision.show?.dates} • {decision.show?.country || 'United Arab Emirates'}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 ps-4 d-flex flex-column justify-content-between">
                        <div>
                            <div className="text-muted mb-1" style={{ fontSize: '10px', letterSpacing: '1px', textTransform: 'uppercase', fontWeight: 'bold' }}>
                                {translate('web.penaltiesSummary', 'PENALTIES SUMMARY')}
                            </div>
                            <p className="mb-0 text-dark" style={{ fontSize: '13px', lineHeight: '1.6', whiteSpace: 'pre-line' }}>
                                {decision.penaltiesSummary}
                            </p>
                        </div>
                        <div className="mt-3 text-end">
                            <button className="btn btn-outline-danger btn-sm px-4" style={{ borderRadius: '20px' }}>
                                {translate('web.viewDetails', 'View Details')} <i className="fa-solid fa-arrow-right ms-2" style={{ fontSize: '12px' }}></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
